import { isDef as i, isObject as s } from "./index.js";
var c = Object.prototype.hasOwnProperty;
function a(e, n, r) {
  var t = n[r];
  i(t) && (!c.call(e, r) || !s(t) ? e[r] = t : e[r] = p(Object(e[r]), n[r]));
}
function p(e, n) {
  return Object.keys(n).forEach(function (r) {
    a(e, n, r);
  }), e;
}
export { p as deepAssign };
